import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';
import axios from 'axios';
import backend_url from "../../../../routes/API_URL";
import swal from 'sweetalert';

const API_URL = backend_url['api_url'];

class ProgressGraph extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      Graph_Data: [],
      bearer_auth: window.sessionStorage.getItem('token'),
      loading: true,
      error: null,
      series: [],
      options: {
        chart: {
          type: 'bar',
          height: 500,
          stacked: false,
          toolbar: {
            show: true
          }
        },
        colors: ['#FF8C00', '#3498db', '#2ecc71', '#e74c3c', '#9b59b6', '#f1c40f', '#1abc9c', '#e67e22'],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: [],
          title: {
            text: 'National Education Standards'
          },
          labels: {
            rotate: -45,
            trim: true,
            maxHeight: 120
          }
        },
        yaxis: {
          title: {
            text: 'Average NES Level'
          },
          min: 0,
          max: 4,
          tickAmount: 4,
          labels: {
            formatter: function(val) {
              return val.toFixed(1);
            }
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val + " (Level)";
            }
          }
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
          fontSize: '12px',
          itemMargin: {
            horizontal: 10,
            vertical: 5
          }
        },
        title: {
          text: 'NATIONAL PROGRESS OVERVIEW',
          align: 'center',
          style: {
            fontSize: '16px',
            fontWeight: 'bold'
          }
        },
        noData: {
          text: 'Loading data...',
          align: 'center',
          verticalAlign: 'middle',
          style: {
            fontSize: '14px',
            color: '#666'
          }
        }
      }
    };
  }
  
  componentDidMount() {
    this.fetchProgressData();
  }
  
  fetchProgressData() {
    const { bearer_auth } = this.state;
    
    if (!bearer_auth) {
      this.setState({
        error: 'No authentication token',
        loading: false
      });
      return;
    }
    
    this.setState({ loading: true });
    
    axios.get(`${API_URL}/progress_report/`, {
      headers: { "Authorization": `Bearer ${bearer_auth}` }
    })
    .then(response => {
    
      this.processData(response.data);
    })
    .catch(error => {
      console.error('Error loading progress data:', error);
      this.setState({ 
        error: 'Failed to load progress data',
        loading: false 
      });
      
      swal({
        title: "",
        text: "Failed to load progress data. Please refresh the page.",
        icon: "error",
        timer: 3000
      });
    });
  }
  
  processData(Graph_Data) {
    if (!Graph_Data || Graph_Data.length === 0) {
      this.setState({
        loading: false,
        error: 'No data available',
        series: []
      });
      return;
    }

    try {
      // Get unique years and sort them
      const years = [...new Set(Graph_Data.map(item => item['DATE']))]
        .filter(year => year) // Remove null/undefined
        .sort();
      
      // Get unique NES items and sort them
      const nesItems = [...new Set(Graph_Data.map(item => item['nes_id']))]
        .filter(nes => nes) // Remove null/undefined
        .sort((a, b) => a - b);
      
     
      if (years.length === 0 || nesItems.length === 0) {
        this.setState({
          loading: false,
          error: 'Insufficient data for chart',
          series: []
        });
        return;
      }
      
      // Limit to last 10 years to avoid overcrowding
      const recentYears = years.slice(-10);
      
      // Create series for each year
      const series = recentYears.map(year => {
        const yearData = Graph_Data.filter(item => item['DATE'] === year);
        
        // Create data array for each NES item
        const data = nesItems.map(nes => {
          const item = yearData.find(d => d['nes_id'] === nes);
          // Parse achievement value, default to 0 if not found
          const value = item ? parseFloat(item['level_achieved']) || 0 : 0;
          return value;
        });
        
        return {
          name: year.toString(),
          data: data
        };
      });
      
      // Format NES labels
      const nesLabels = nesItems.map(nes => `NES ${nes}`);
      
      this.setState(prevState => ({
        Graph_Data,
        series: series,
        loading: false,
        options: {
          ...prevState.options,
          xaxis: {
            ...prevState.options.xaxis,
            categories: nesLabels
          }
        }
      }));

    } catch (error) {
      console.error('Error processing data:', error);
      this.setState({
        loading: false,
        error: 'Error processing chart data',
        series: []
      });
    }
  }
  
  render() {
    const { series, options, loading, error } = this.state;
    
    if (loading) {
      return (
        <div className="text-center p-5">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <p className="mt-2">Loading progress data... (Processing {this.state.Graph_Data.length} records)</p>
        </div>
      );
    }
    
    if (error) {
      return (
        <div className="text-center p-5">
          <h5 className="text-danger">{error}</h5>
          <p>Unable to load progress data.</p>
          <button 
            className="btn btn-primary mt-3"
            onClick={() => this.fetchProgressData()}
          >
            Retry
          </button>
        </div>
      );
    }
    
    if (!series || series.length === 0) {
      return (
        <div className="text-center p-5">
          <h5>No Progress Data Available</h5>
          <p>There is no inspection data available for the selected period.</p>
        </div>
      );
    }
    
    // Ensure series data is valid before rendering
    const hasValidData = series.every(s => Array.isArray(s.data) && s.data.length > 0);
    
    if (!hasValidData) {
      return (
        <div className="text-center p-5">
          <h5>Invalid Data Format</h5>
          <p>The data format is not suitable for display.</p>
        </div>
      );
    }
    
    return (
      <div className="col-12">
        <ReactApexChart 
          options={options} 
          series={series} 
          type="bar" 
          height={500} 
        />
        <div className="text-muted text-center mt-2">
          <small>Showing data for last {series.length} years</small>
        </div>
      </div>
    );
  }
}

export default ProgressGraph;